import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1 disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0 max-md:min-h-[44px]",
  {
    variants: {
      variant: {
        default:
          "bg-hocp-mint text-hocp-deepTeal font-semibold shadow hover:bg-hocp-mintStrong disabled:opacity-100 disabled:bg-[#F4FCFC] disabled:border disabled:border-[#E6EFF0] disabled:text-[#97A6A9] disabled:shadow-none",
        destructive:
          "bg-[#FEE2E2] border border-[#DC2626] text-[#991B1B] font-semibold hover:bg-[#FECACA] disabled:opacity-100 disabled:bg-[#F4FCFC] disabled:border disabled:border-[#E6EFF0] disabled:text-[#97A6A9] disabled:shadow-none",
        outline:
          "bg-white border border-[#D5E6E8] text-[#014751] shadow-sm hover:bg-[#F4FCFC] hover:text-[#014751] disabled:opacity-100 disabled:bg-[#F4FCFC] disabled:border disabled:border-[#E6EFF0] disabled:text-[#97A6A9] disabled:shadow-none",
        soft:
          "bg-[#E6FEFF] border border-[#37F4B5] text-[#014751] font-semibold hover:bg-[#DBFCEF] hover:border-[#2CE3A6] disabled:opacity-100 disabled:bg-[#F4FCFC] disabled:border disabled:border-[#E6EFF0] disabled:text-[#97A6A9] disabled:shadow-none",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
